import { Device } from '@twilio/voice-sdk';

export function createBrowserVoiceDevice(token) {
  if (!Device.isSupported) {
    throw new Error('This browser does not support secure voice calls.');
  }
  return new Device(token, {
    enableImprovedSignalingErrorPrecision: true,
    logLevel: 'error',
    maxCallSignalingTimeoutMs: 15000,
  });
}
